import { create } from "zustand";

let _nextId = 1;
const uid = () => _nextId++;

const useCopilotStore = create((set) => ({
  messages: [],          // [{ id, role, content }]
  isOpen: false,
  isStreaming: false,
  streamingId: null,     // id of the assistant message currently being written

  togglePanel: () => set((s) => ({ isOpen: !s.isOpen })),
  openPanel:   () => set({ isOpen: true }),

  addUserMessage: (content) => {
    const msg = { id: uid(), role: "user", content };
    set((s) => ({ messages: [...s.messages, msg] }));
    return msg;
  },

  startAssistantMessage: () => {
    const id = uid();
    const msg = { id, role: "assistant", content: "" };
    set((s) => ({ messages: [...s.messages, msg], isStreaming: true, streamingId: id }));
    return id;
  },

  appendDelta: (id, delta) =>
    set((s) => ({
      messages: s.messages.map((m) =>
        m.id === id ? { ...m, content: m.content + delta } : m
      ),
    })),

  finishStreaming: () => set({ isStreaming: false, streamingId: null }),

  clearMessages: () => set({ messages: [] }),
}));

export default useCopilotStore;
